"use client";
import Script from "next/script";

interface ChatbotScriptProps {
  isEnabled: boolean;
}

export default function ChatbotScript({ isEnabled }: ChatbotScriptProps) {
  if (!isEnabled) return null;

  return (
    <Script
      src="https://www.kenyt.ai/botapp/ChatbotUI/dist/js/bot-loader.js"
      data-bot="260496351"
      strategy="lazyOnload"
    />
  );
}
